/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// CONCATENATED MODULE: ./src/js/CustomProduct.js
class CustomProduct {
  price = 0;
  cpbLoaded = false;
  intervalDependencies = null;
  cpbTitleLoaded = false;
  intervalCpbTitle = false;
  cpbCategoryLoaded = false;
  intervalCpbCategory = false;

  init = () => {
    const cpbProduct = document.querySelector(
      '[id*="shopify-block-cpb_custom_product_builder"]'
    );

    if (cpbProduct) {
      const checkDependencies = () => {
        if (
          !this.cpbLoaded &&
          window.hasOwnProperty('CPB') &&
          window.CPB.getStore().getState().Product.price
        ) {
          this.cpbLoaded = true;
          this.getProductPrice();
        }
      };

      this.addSizingGuideLink();

      this.intervalDependencies = setInterval(checkDependencies, 100);

      document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', () => {
        this.getProductPrice();
      });
    }
  };

  getProductPrice = () => {
    clearInterval(this.intervalDependencies);
    this.price = window.CPB.getStore().getState().Product.price;
    this.displayNewPrice(this.price);
  };

  displayNewPrice = (price) => {
    const customPrice = document.querySelector('.cpb-custom-price');

    if (customPrice) {
      customPrice.innerHTML = `${price} €`;
    } else {
      const newPrice = document.createElement('span');
      newPrice.classList.add('cpb-custom-price');
      newPrice.innerHTML = `${price} €`;

      const checkCpbTitle = () => {
        const cpbTitle = document.querySelector('.cpb-product-title');
        if (!this.cpbTitleLoaded && cpbTitle) {
          this.addBreadcrumbs(cpbTitle);
          cpbTitle.after(newPrice);
          this.cpbTitleLoaded = true;
          clearInterval(this.intervalCpbTitle);
        }
      };

      this.intervalCpbTitle = setInterval(checkCpbTitle, 100);
    }
  };

  addSizingGuideLink = () => {
    const url = window.themeVariables.settings.sizingGuideUrl;
    const label = window.themeVariables.strings.sizingGuideLabel;

    if (url) {
      const sizignGuideLink = document.createElement('a');
      sizignGuideLink.classList.add('cpb-custom-sizing-link');
      sizignGuideLink.href = `/pages/${url}`;
      sizignGuideLink.target = '_blank';
      sizignGuideLink.innerHTML = label;

      const checkCpbCategory = () => {
        const cpbCategory = document.querySelector(
          '.cpb-category-text:first-child > .cpb-category-content'
        );

        if (!this.cpbCategoryLoaded && cpbCategory) {
          cpbCategory.after(sizignGuideLink);
          this.cpbCategoryLoaded = true;
          this.addReassurance();
          this.addShareButtons();
          clearInterval(this.intervalCpbCategory);
        }
      };

      this.intervalCpbCategory = setInterval(checkCpbCategory, 100);
    }
  };

  addBreadcrumbs = (title) => {
    const breadcrumbs = document.querySelector('.breadcrumbs');

    if (breadcrumbs && title) {
      title.before(breadcrumbs);
    }
  };

  addReassurance = () => {
    const cpbProductActions = document.querySelector('.cpb-product-actions');
    this.reassurance = document.querySelector(
      '.text-with-icons--product-reassurance'
    );

    if (cpbProductActions && this.reassurance) {
      cpbProductActions.after(this.reassurance);
    }
  };

  addShareButtons = () => {
    const shareButtons = document.querySelector('.wq-share-buttons');
    if (shareButtons && this.reassurance) {
      shareButtons.style.opacity = '1';
      this.reassurance.after(shareButtons);
    }
  };
}

;// CONCATENATED MODULE: ./src/js/ObfLinks.js
class ObfLinks {
  init = () => {
    this.eventTypes = ['mouseover', 'focusin'];

    this.links = document.querySelectorAll('[data-href]');

    if (this.links.length > 0) {
      this.eventTypes.forEach((eventType) => {
        document.addEventListener(eventType, () =>
          this.mouseOverHandler(this.links)
        );
      });

      this.links.forEach((item) => {
        item.addEventListener('click', () => this.clickHandler(item));
      });
    }
  };

  mouseOverHandler = (links) => {
    links.forEach((item) => this.transformHref(item));
    this.eventTypes.forEach((eventType) => {
      document.removeEventListener(eventType, this.mouseOverHandler);
    });
  };

  transformHref = (element) => {
    if (element.dataset.href) {
      element.href = atob(element.dataset.href);
      delete element.dataset.href;
    }
  };

  clickHandler = (item) => {
    this.transformHref(item);
    item.removeEventListener('click', this.clickHandler);
  };
}

;// CONCATENATED MODULE: ./src/main.js


// JS goes here



window.addEventListener('load', () => {
  const classes = [new CustomProduct(), new ObfLinks()];
  classes.forEach((classe) => classe.init());
});

/******/ })()
;